<template>
  <div class="infos">
    <a-collapse :activeKey="activeKey" :bordered="false">
      <a-collapse-panel
        :key="String(index + 1)"
        :header="item.name"
        v-for="(item, index) in infoList"
        
      >
        <div v-if="item.type === 'content'">
          <div class="abstract">
            <div class="abstractContent" v-html="item.content"></div>
            <div v-viewer>
              <img
                v-lazy="item.imgs[0]"
                :key="1"
                class="abstractImg"
                v-if="item.imgs.length > 0"
              />
            </div>
          </div>
        </div>
        <div v-else-if="item.type === 'form'">
          <div class="elementInformation">
            <a-row
              class="elementRow"
              v-for="(rowItem, rowIndex) in item.form"
              :key="'rowItem' + rowIndex"
            >
              <a-col class="rowLabel">{{ rowItem.label }}</a-col>
              <a-col class="rowValue" v-html="rowItem.value"></a-col>
            </a-row>
          </div>
        </div>
        <div v-else-if="item.type === 'table'">
          <a-table
            bordered
            :data-source="item.table"
            :columns="item.columns"
            :pagination="false"
          >
          </a-table>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import { infoList } from './config/index'

export default {
  props: {
    detailObj: Object,
    fileList: Object
  },
  data() {
    return {
      isShowImg: false,
      infoList,
      activeKey: []
    }
  },
  components: {},
  computed: {},
  watch: {
    detailObj() {
      this.activeKey = []
      this.init()
    },
    fileList(val){
      if(val){
        this.activeKey = []
        this.init()
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.infoList.forEach((item, index) => {
        if(this.activeKey.indexOf(ele=>ele !== index+1)){
          this.activeKey.push(index + 1)
        }
        if (item.type === 'content') {
          item.content = this.detailObj.abstract_ab
          const imgs = []
          if(this.fileList.zyFile){
            imgs.push(this.fileList.zyFile.filePath)
            item.imgs = imgs
          }else{
            item.imgs = []
          }
          
        }
        if (item.name === '著录项信息') {
          // eslint-disable-next-line no-restricted-syntax
          for (const [i] of Object.entries(this.detailObj)) {
            item.form.forEach((ele) => {
              if (ele.key === i) {
                if (Array.isArray(this.detailObj[i])) {
                  // eslint-disable-next-line vue/no-mutating-props
                  this.detailObj[i] = this.detailObj[i].join(',')
                }
                ele.value = this.detailObj[i]
              }
            })
          }
        }
        if (item.name === '分类信息') {
          item.form.forEach((ele) => {
            if (ele.label === 'IPC分类号') {
              let str = ''
              if (this.detailObj.ipc_li) {
                str = `${this.detailObj.ipc_main_stat
                }(主)<span class="pl15"></span>${
                  this.detailObj.ipc_li.join('<span class="pl15"></span>')}`
                ele.value = str
              }
            }
            if (ele.label === '国民经济分类号') {
              let strIpc = ''
              if (this.detailObj.icnea_type) {
                strIpc = this.detailObj.icnea_type.join(
                  '<span class="pl15"></span>'
                )
                ele.value = strIpc
              }
            }
          })
        }
        if (item.name === '法律信息') {
          const lawArr = this.detailObj.legal_event_status_json
          if (lawArr) {
            const newLaw = lawArr.map((res, key) => {
              res = JSON.parse(res)
              res.key = key
              return res
            })

            item.table = newLaw
          }
        }
        if (item.name === '同族信息') {
          const familyArr = this.detailObj.family_info
          if (familyArr) {
            item.form.forEach((ele) => {
              if (ele.label === '同族专利公开号') {
                ele.value = familyArr.join('<span class="pl15"></span>')
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
